export enum StorageKeysEnum {
  ACCESS_TOKEN = 'ACCESS_TOKEN',
  ACCESS_TOKEN_WSO = 'ACCESS_TOKEN_WSO',
  REFRESH_TOKEN = 'REFRESH_TOKEN',
  USER_INFO = 'USER_INFO',
  SIT_USUARIO = 'SIT_USUARIO',
  COORDS = 'COORDS',
  IP = 'IP',
  CONTRACTS_INFORMATION = 'CONTRACTS_INFORMATION',
  PUBLIC_KEY = "PUBLIC_KEY",
  PRIVATE_KEY = "PRIVATE_KEY",
  CURRENT_LANGUAGE = "CURRENT_LANGUAGE",
  TOAST = 'toast',
  CONTRACTS_FACMAN = 'CONTRACTS_FACMAN'
}
